import s from '../../../../../commonStyles.modules.scss'
import { BasicTable } from '@fullscreendigital/carrefour-dex-fe'
import { columns } from './helpers'
import { TableContainer } from "@mui/material";

const TruckSupport = ({ truck, isHistorical }) => {
  return (
    <TableContainer style={{ marginTop: 15, maxHeight: 600 }}>
      <BasicTable
        columns={columns(isHistorical)}
        rows={truck?.supportList || []}
        containerProps={{
          className: s.table
        }}
      />
    </TableContainer>
  )
}

export default TruckSupport
